import React, { useEffect, useState } from 'react'
import {
  withRouter, Route, Redirect, useHistory
} from 'react-router-dom';
import getSource from '../utils/get-source';
import { parseQueryString } from '../utils/utils';
import { initialState, combineReducers } from '../reducers'
import { AppStateProvider } from '../contexts/appState'
import { StateProvider } from "../components/SlotFinder/store/stateProvider"
import reducer, { initialStates } from "../components/SlotFinder/store/reducer"
import userReducer from '../reducers/userReducer'
import HomePage from './HomePage';
import OnBoardingWrapper from './OnboardingWrapper';
import Results from './OnBoarding/Results';
import { AnimatedSwitch } from './AnimatedSwitch';
import Header from './Header';
import './styles/homescreen.css';
import Workflow from './workflowEngine';
import WorkFlowResults from './workflowEngine/Results';
import Footer from './Footer/Footer';
import History from './History/History'
import VaccinationDetails from './VaccinationDetails'
import VaccinationDetailsWrapper from './VaccinationDetails/VaccinationDetailsWrapper'
import VaccinationWrapperMobile from './VaccinationMobile'
import VaccinationScWrapper from './VaccinationSc'
import BookAppointments from './BookAppointments'
import VaccinationCertiCat from './VaccinationCertificate/Category';
import VaccinationCertiCowin from './VaccinationCertificate/Cowin';
import VaccinationCertiJhhIdVerify from './VaccinationCertificate/JhhIdVerify';
import MyVaccination from './my-vaccination'
import Sidebar from './Sidebar';
import Profile from './Profile';
import VaccineFaqs from './VaccineFAQs';
import BookedAppointmentDetails from './BookedAppointmentDetails';
// import VaccinationCertiReliance from './VaccinationCertificate/Reliance';
import { useIsTablet, useIsMobile } from '../hooks/breakpoints';
import configMenu from './Sidebar/config.js';
import SlotFinder from './SlotFinder'
import SlotList from '../components/SlotFinder/slot-list'
import ReadBarcode from "./BarcodeReader";
const routes = {
  '/': <HomePage />,
  '/workflow': <OnBoardingWrapper />,
  '/workflow/results': <Results />,
  '/workflow/:questionId': <OnBoardingWrapper />,
  '/vaccination-sc': <VaccinationScWrapper />,
  '/vaccination-mobile': <VaccinationWrapperMobile />,
  '/general-workflow': <Workflow />,
  '/general-workflow/results': <WorkFlowResults />,
  '/general-workflow/:questionId': <Workflow />,
  '/vaccination-details': <VaccinationDetails />,
  '/vaccination-interest': <VaccinationDetailsWrapper />,
  '/vaccination-certificate/category': <VaccinationCertiCat />,
  '/vaccination-certificate/cowin': <VaccinationCertiCowin />,
  '/vaccination-certificate/verifyjhhid': <VaccinationCertiJhhIdVerify />,
  '/vaccination-sc/verifyjhhid': <VaccinationCertiJhhIdVerify flow='smart_sc' />,
  '/vaccination-info/verifyjhhid': <VaccinationCertiJhhIdVerify flow='vaccination_info' />,
  '/my-appointment/scheduled': <BookedAppointmentDetails type='upcoming' />,
  '/my-appointment/completed': <BookedAppointmentDetails type='past' />,
  '/scanner': <ReadBarcode />,
  // '/vaccination-certificate/reliance': <VaccinationCertiReliance />,
  // '/cp-scan-history': <History />,
  '/profile': <Profile />,
  '/vaccinations-v2/verifyjhhid': <VaccinationCertiJhhIdVerify flow='vaccination_v2' />,
  '/book-appointment/all-centers': <BookAppointments flow='all' />,
  '/book-appointment/corporate': <BookAppointments flow='corporate' />,
  '/profile': <Profile />,
  '/vaccine-faqs': <VaccineFaqs />,
  '/my-vaccinations/:dose': <MyVaccination />,
  '/vaccination-slot-finder': <SlotFinder />,
  '/vaccination-slot-finder/slot-list': <SlotList />
};

const getSourceId = async () => {
  const { source_id } = parseQueryString()
  if (source_id) {
    return Promise.resolve(source_id)
  }
  const sourceData = await getSource()
  return sourceData.source_id
}
const appReducers = combineReducers({
  user: userReducer,
})

const Routes = withRouter(({ location }) => {
  const [state, setState] = useState({
    source_id: null
  })
  const [hideHeader, setHideHeader] = useState(false);
  const isMobile = useIsMobile();

  useEffect(() => {
    (async () => {
      const source_id = await getSourceId()
      setState(prevState => ({
        ...prevState,
        source_id
      }))
      setHideHeader(() => parseQueryString().hideHeader == 'false' ? false : true)
    })()
  }, [])

  const isTablet = useIsTablet();
  const history = useHistory();
  let covidVaccinationUrls = configMenu.map(item => item.url)
  configMenu.filter(item => item.nodes && item.nodes.length > 0).forEach(item => {
    item.nodes.forEach(nodeItem => {
      covidVaccinationUrls.push(nodeItem.url);
    })
  })
  return (
    <AppStateProvider reducer={appReducers} initialState={initialState}>
      <StateProvider initialState={initialStates} reducer={reducer}>
        <div
          style={{
            minHeight: '100vh',
            height: '100vh',
            backgroundColor: '#F6F6F6'
          }}
          onCopy={e => e.preventDefault()}
        >
          <Header shouldHide={(state.source_id && (state.source_id === 'JioHealthHub' || state.source_id === "MyJio" || state.source_id === "JhhWebApp") && hideHeader)} />
          <div
            className={`${covidVaccinationUrls.includes(history.location.pathname) ? 'app-container' : 'app-container-old'}`}
            style={{ height: 'auto', minHeight: '100vh' }}>
            <Sidebar />
            <div id='switch-container' style={{
              paddingTop: (state.source_id && state.source_id === "MyJio") ? '' : "0rem",
              width: `${(isTablet || isMobile) ? "100%" : "auto"}`,
              height: 'auto'
            }}>
              <AnimatedSwitch location={location}>
                {Object.entries(routes).map(([path, component]) => (
                  <Route
                    exact
                    key={path}
                    path={path}
                  >
                    <div
                      className={`component ${state.source_id
                        && (state.source_id === 'JioHealthHub' || state.source_id === "MyJio")
                        || state.source_id === "JhhWebApp" ? 'paddingBottomSmall' : ''}`}
                      style={{ height: "100%", width: "100%" }}>{component}</div>
                  </Route>
                ))}
              </AnimatedSwitch>
            </div>
          </div>
          <Footer shouldHide={state.source_id && (state.source_id === 'JioHealthHub' || state.source_id === "MyJio") || state.source_id === "JhhWebApp"} />
        </div>
      </StateProvider>
    </AppStateProvider>
  );
});
export default Routes;
